import React from 'react';
import { REGEX_CONSTANTS } from '@components-shared/constants';
import cn from 'classnames';
import './styles.scss';

interface IProps {
  step?: number;
  precision?: number;
  onChange: (value: string | number) => void;
  value: string;
  hideNumericArrows?: boolean;
  className?: string;
  disabled?: boolean;
  allowNegativeValues?: boolean;
  name?: string;
}

const NumericInput: React.FC<IProps> = (props) => {
  const {
    step: originalStep,
    precision,
    onChange,
    value,
    hideNumericArrows,
    className,
    disabled,
    allowNegativeValues,
    name,
  } = props;

  const valueNumber = value === '+' || value === '-' ? 0 : Number(value);
  const isBlockDecrementForNegativeValue = valueNumber <= 0;
  const step = originalStep ?? 1;

  const onChangeNumericInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const reg = allowNegativeValues
      ? REGEX_CONSTANTS.ONLY_DIGITS_PATTERN
      : REGEX_CONSTANTS.ONLY_NOT_NEGATIVE_DIGITS_PATTERN;

    if (value === '' || value.match(reg)) {
      const updatedValue = getPrecisionCorrectedValue(value, precision);

      onChange(updatedValue);
    }
  };

  const getPrecisionCorrectedValue = (value: string, precision?: number) => {
    if (typeof precision === 'undefined') return value;

    // eslint-disable-next-line no-useless-escape
    const regWithPrecision = new RegExp(`[^\\d\+\-]*(\\d+([\.\,]\\d{0,${precision}})?).*$`, 'g');
    const updatedValue = value.replace(regWithPrecision, '$1');

    return precision === 0 ? updatedValue.replace(/[.,]$/g, '') : updatedValue;
  };

  const onIncrement = () => {
    const result = valueNumber + step;
    const fixedResult = result.toFixed(10);
    const fixedResultToString = Number(fixedResult).toString();

    onChange(fixedResultToString);
  };

  const onDecrement = () => {
    const result = valueNumber - step;
    const fixedResult = result > 0 ? result.toFixed(10) : 0;
    const fixedResultToString = Number(fixedResult).toString();

    onChange(fixedResultToString);
  };

  return (
    <span className="numeric-input">
      <input
        className={className}
        disabled={disabled}
        type="text"
        value={value}
        onChange={onChangeNumericInput}
        name={name}
      />

      {!hideNumericArrows && (
        <React.Fragment>
          <b className="numeric-input__btn numeric-input__btn--up" onClick={onIncrement}>
            <i className="numeric-input__arrow numeric-input__arrow--up" />
          </b>

          <b
            className={cn('numeric-input__btn numeric-input__btn--down', {
              disabled: isBlockDecrementForNegativeValue,
            })}
            onClick={onDecrement}>
            <i className="numeric-input__arrow numeric-input__arrow--down" />
          </b>
        </React.Fragment>
      )}
    </span>
  );
};

export default NumericInput;
